export const language: any ={
    LabelFavorites: "Favorites",
    LabelYouDontHaveRecipeAddYourFavoriteRecipe: `You don't have any favorite dishes yet.<br/>Add your favorite dishes!`,
    LabelDoYouWantUnSave: `Would you like to unsave this recipe?`,
    save: 'Save',
    unsave: 'Save',
    OkFavorite: "Yes",
    CloseFavorite: "No",
}

